module.exports = __webpack_public_path__ + "media/images/share-medium-d4cfa9abb39f6576a4268026010b78bd.svg";